import { render, staticRenderFns } from "./szjz.vue?vue&type=template&id=8beb7a18&scoped=true"
import script from "./szjz.vue?vue&type=script&lang=js"
export * from "./szjz.vue?vue&type=script&lang=js"
import style0 from "./szjz.vue?vue&type=style&index=0&id=8beb7a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8beb7a18",
  null
  
)

export default component.exports